/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { FancyFirebaseObject } from '../base/FancyFirebaseObject';
import { Milestone } from '@touchplan/common';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';

/**
 * Plan Milestone creates an active listener for data changes on Firebase in the
 * Root/plans/{projectId}/{planId}/milestone path
 * On chance, it emits a object that matches the Milestone interface from @touchplan/common
 */
export class PlanMilestone extends FancyFirebaseObject<Milestone> {
	constructor(angularLand: AngularLandConnection, path: RefOrObservable) {
		super(angularLand, path);
	}
	/**
	 * Called when the data on firebase is changed
	 * @param child
	 */
	public $$updated(child: any) {
		if (!child || !child.payload.exists()) {
			return {};
		}
		return Object.assign({}, child.payload.val()) as Milestone;
	}
}
